import React, { FC } from 'react';
import { Badge, Tooltip } from 'antd';
import { grey } from '@ant-design/colors';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { TaskStatus } from '@lib/services/_api';

const TaskState: FC<{ data: any; value: TaskStatus }> = ({ data, value }) => {
  if (value === TaskStatus.DEPLOYING) {
    return <Badge status="processing" text={value} />;
  }
  if (value === TaskStatus.SUCCESS) {
    return <Badge status="success" text={value} />;
  }
  if (value === TaskStatus.FAIL) {
    return (
      <Tooltip title={data.message?.split('\n')?.shift()}>
        <Badge status="error" text={value} />
        <ExclamationCircleOutlined className="ml-2" />
      </Tooltip>
    );
  }
  if (value === TaskStatus.TIMEOUT) {
    return <Badge status="warning" text={value} />;
  }

  return <Badge color={grey.primary} text={value} />;
};

export default TaskState;
